import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField";
import {Merchant} from "../MerchantStore";
import {MerchantUser} from "./MerchantUserStore";
import {StemDate} from "../../../stem-core/time/Date";

@globalStore
export class MerchantConversion extends BaseStore("MerchantConversion") {
    declare metadata: Record<string, any>;
    @field("Merchant") merchant: Merchant;
    @field("MerchantUser") merchantUser: MerchantUser;
    @field(Date) createdAt: StemDate;
}
